import { Injectable } from '@angular/core';
import Pusher, { Channel } from 'pusher-js';
import { GlobalVariables } from '../global';
import { NewTokenData, NewAlertData, NewBranchQueueBroadcastData } from '../_types/pusher.types';

export { NewTokenData, NewAlertData, NewBranchQueueBroadcastData } from '../_types/pusher.types';

@Injectable()
export class PusherService {
  private pusher: Pusher;
  private channels: Channel[] = [];
  public tokenBroadcastChannel?: Channel;
  public alertBroadcastChannel?: Channel;
  public branchQueueBroadcastChannel?: Channel;

  constructor() {
    const { app_cluster, app_key } = GlobalVariables.PUSHER_CONFIG;
    this.pusher = new Pusher(app_key, { cluster: app_cluster });
  }

  connectTokenBroadcast(
    branchId: number | string,
    newDataHandler: (data: NewTokenData) => void,
    newAlertHandler?: (data: NewAlertData) => void,
  ): boolean {
    this.disconnectAllChannels();

    try {
      if (newDataHandler) {
        this.tokenBroadcastChannel = this.pusher.subscribe(`token-broadcast-${branchId}`);
        this.channels.push(this.tokenBroadcastChannel);
        this.tokenBroadcastChannel.bind('token-sync', newDataHandler);
      }
      if (newAlertHandler) {
        this.alertBroadcastChannel = this.pusher.subscribe(`alerts-${branchId}`);
        this.channels.push(this.alertBroadcastChannel);
        this.alertBroadcastChannel.bind('alert-sync', newAlertHandler);
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  connectToAlertBroadcast(branchId: number | string, newDataHandler: (data: NewAlertData) => void): boolean {
    this.disconnectChannel(this.alertBroadcastChannel);

    try {
      const alertChannel = this.pusher.subscribe(`alert-${branchId}`);
      this.channels.push(alertChannel);
      alertChannel.bind('alert-sync', newDataHandler);
      return true;
    } catch (error) {
      console.error('Error connecting to alert broadcast:', error);
      return false;
    }
  }

  connectToBranchQueueBroadcast(
    branchId: number | string,
    newDataHandler: (data: NewBranchQueueBroadcastData) => void,
  ): boolean {
    this.disconnectChannel(this.branchQueueBroadcastChannel);

    try {
      const branchQueueChannel = this.pusher.subscribe(`branch-queue-broadcast-${branchId}`);
      this.channels.push(branchQueueChannel);
      branchQueueChannel.bind('branch-queue-sync', newDataHandler);
      return true;
    } catch (error) {
      console.error('Error connecting to branch queue broadcast:', error);
      return false;
    }
  }

  disconnectAllChannels() {
    this.channels.forEach((it) => {
      it && it.unbind_all();
      it && it.unsubscribe();
      it && it.disconnect();
    });
    this.tokenBroadcastChannel = undefined;
    this.alertBroadcastChannel = undefined;
    this.branchQueueBroadcastChannel = undefined;
    this.channels = [];
  }

  disconnectChannel(channel?: Channel) {
    if (channel) {
      channel.unbind_all();
      channel.unsubscribe();
      channel.disconnect();
      this.channels = this.channels.filter((it) => it !== channel);
    }
    channel = undefined;
  }
}
